var ko = require('knockout');
var bindingHandlers = ko.bindingHandlers;

var dragDrop = require('./drag_drop.js');
bindingHandlers.drag = dragDrop.drag;
bindingHandlers.drop = dragDrop.drop;

// Bindings that are possibly used somewhere in the legacy backend
bindingHandlers.datepicker = require('./datepicker.js');
bindingHandlers.expanded = require('./expanded.js');
bindingHandlers.hover = require('./hover.js');
bindingHandlers.keyboard = require('./keyboard.js');
bindingHandlers.preventDoubleSubmit = require('./prevent_double_submit.js');
bindingHandlers.tooltip = require('./tooltip.js');

// Used by the filter sidebar in legacy backend
bindingHandlers.pegWithinParent = require('./peg_within_parent.js');
